import type { OnchainProof } from "@crewledger/shared/schemas";
import { apiFetch } from "@/lib/api";

export async function fetchOnchainProof(payPeriodId: string) {
  return apiFetch<{ data: OnchainProof | null }>(`/api/onchain/pay-periods/${payPeriodId}`);
}

export async function generateOnchainMerkleRoot(payPeriodId: string) {
  return apiFetch<{
    data: { proof: OnchainProof; workerCount: number };
  }>(`/api/onchain/pay-periods/${payPeriodId}/generate`, { method: "POST" });
}

export async function publishOnchainProof(payPeriodId: string) {
  return apiFetch<{ data: { proof: OnchainProof } }>(
    `/api/onchain/pay-periods/${payPeriodId}/publish`,
    { method: "POST" },
  );
}
